import { Bounce, toast } from "react-toastify";
import { consoleLog } from "../services/consoleLog";
export default function ShowToast(message: any, type : any, position: any = "bottom-left") {
  const toastParam: any = {
    position: position,
    autoClose: 2500,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    hideProgressBar: false,
    theme: "colored",
    transition: Bounce,
    toastId: 'toast-erp-id-1'
  };
  const toastLoad = (type: any) => {
    switch (type) {
      case "success":
        toast.success(message, toastParam);
        break;
      case "error":
        toast.error(message, toastParam);
        break;
      case "info":
        toast.info(message, toastParam);
        break;
      default:
        consoleLog("Toast type invalid. [success, error, info] ", type);
    }
  };
  toastLoad(type);
}
